import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from '../common.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
	respdata: any;
	response: any;
	cookietoken: any;
	constructor(private router: Router, private commonService: CommonService) { }

	/*
	* Created By : PriyaDharshini M
	* Description : used to restrict the accessing of different components according to type of user logged in.
	*********************************************/
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		var userFlag = false;
		var currentUrl = (state.url).split('/');
		/* let tmpUserType = this.cookie.get('userProfile'); */
		let tmpUserType = window.localStorage.getItem('userProfile');
		var getUserType = this.commonService.decryptData(tmpUserType);
		var allowedModule = [];
		var restrictedModule = ['change-password', 'contactus'];
		var getToken = sessionStorage.getItem('token');
		/* var getToken =window.localStorage.getItem('token'); */
		let tmpAuth = window.localStorage.getItem('auth');
		/* let tmpAuth = this.cookie.get('auth'); */
		var getAuth = this.commonService.decryptData(tmpAuth);
		if (getUserType == 'helpdesk' || getUserType == 'underwriter') {
			allowedModule = ['declaration', 'soa', 'reports', 'masters'];
		}
		else if (getUserType == 'hub') {
			allowedModule = ['master-policy-complete', 'policy-configuration', 'declaration', 'soa', 'reports','policy_enable'];
		}
		/* else if (getUserType == 'producerUser') {
			allowedModule = ['soa', 'reports', 'change-password'];
		}
		else if (getUserType == 'clientUser') {
			allowedModule = ['declaration', 'soa', 'reports', 'change-password'];
		} */else if (getUserType == 'producerUser') {
			allowedModule = ['soa', 'declaration', 'change-password'];
		}
		else if (getUserType == 'clientUser') {
			allowedModule = ['declaration', 'soa', 'change-password', 'contactus'];
		}
		else if (getUserType == 'marineclaims' || getUserType == 'rm' || getUserType == 'ops') {
			allowedModule = ['declaration', 'soa', 'reports'];
		}
		else if (getUserType == 'adminview') {
			allowedModule = ['master-policy-complete', 'usersMapping','policy-configuration', 'declaration', 'soa', 'reports', 'masters','audit-trail'];
		}
		
		if (getToken && getAuth) {
			if (getToken == getAuth) {
				if (getUserType == 'helpdesk' || getUserType == 'hub'|| getUserType == 'marineclaims' || getUserType == 'underwriter' || getUserType == 'producerUser' || getUserType == 'clientUser' || getUserType == 'rm' || getUserType == 'adminview' || getUserType == 'ops') {
					let tmpFlag = true;

					for (let path of allowedModule) {
						if (path.indexOf(currentUrl[1]) > -1) {
							return true;
						}
						else {
							tmpFlag = false;
						}
					}

					if (tmpFlag == true) {
						userFlag = true;
					}
					/* else {
						// already userFlag holds `false` value;
						// userFlag = false;
					} */
				}
				else if (getUserType == 'admin') {
					for (let moduleName of restrictedModule) {
						if (moduleName == currentUrl[1]) {
							userFlag = false;
						}
						else {
							userFlag = true;
						}
					}
				}
				else if(getUserType == undefined)
					this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
				// logged in so return true		
				return userFlag;
			}
		}
		
		// not logged in so redirect to login page with the return url
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return userFlag;
	}
	
}
